import { render } from "./Wild.vue?vue&type=template&id=b68822f6"
import script from "./Wild.vue?vue&type=script&lang=js"
export * from "./Wild.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__